module.exports = __webpack_public_path__ + "img/shade-designer-logo-dark.3622ed43.png";